import * as tslib_1 from "tslib";
import { all } from "redux-saga/effects";
import appSagas from "./app";
export default function rootSaga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(appSagas.slice())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/sagas/index.ts
// module id = 267
// module chunks = 0